import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { GroupedBarChart } from "@/components/charts/GroupedBarChart";
import { salesReportApi } from "@/lib/sales-report";

const aud = (n: number) =>
  n.toLocaleString("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: 0 });

export function SalesTrendWidget() {
  const query = useQuery({
    queryKey: ["dashboard-sales-trend"],
    queryFn: () => salesReportApi.monthly(undefined, "revenue"),
  });

  const data = query.data;
  const isEmpty = data ? data.months.every((m) => m.selected === 0 && m.previous === 0) : false;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Sales by Month</CardTitle>
        {data ? (
          <p className="text-sm text-muted-foreground">{data.fyLabel} vs {data.previousFyLabel}</p>
        ) : null}
      </CardHeader>
      <CardContent>
        {query.isLoading ? (
          <Skeleton className="h-[320px] w-full" />
        ) : query.isError ? (
          <p className="text-sm text-muted-foreground">{"Couldn't load sales trend"}</p>
        ) : !data || isEmpty ? (
          <p className="text-sm text-muted-foreground">No sales recorded this financial year</p>
        ) : (
          <GroupedBarChart
            data={data.months.map((m) => ({ label: m.monthLabel, selected: m.selected, previous: m.previous }))}
            selectedName={data.fyLabel}
            previousName={data.previousFyLabel}
            valueFormatter={aud}
          />
        )}
        <div className="mt-3">
          <Link to="/reports/sales-by-month" className="text-sm text-primary underline">View report</Link>
        </div>
      </CardContent>
    </Card>
  );
}
